import {
  DepositForfeitureOutcomeStatus,
  DepositForfeiturePolicy,
} from '@principle-theorem/principle-core/interfaces';
import {
  ISerialisedDocumentReference,
  ISerialisedTimestamp,
} from '@principle-theorem/shared';
import { IAppointmentScopedFact, ITimestampedFact } from './common';

export interface IDepositForfeitureEventFact {
  depositRequestRef: ISerialisedDocumentReference;
  policyAtDecision: DepositForfeiturePolicy;
  configuredPercentage: number;
  defaultShouldForfeit: boolean;
  shouldForfeit: boolean;
  decidedAmountCents?: number;
  overrideReasonProvided: boolean;
  outcomeStatus?: DepositForfeitureOutcomeStatus;
  wasForfeited: boolean;
  forfeitedAmountCents?: number;
  forfeitedAt?: ISerialisedTimestamp;
}

export interface ISchedulingEventFact
  extends IAppointmentScopedFact,
    ITimestampedFact {
  schedulingEventRef: ISerialisedDocumentReference;
  reasonRef?: ISerialisedDocumentReference;
  scheduledByPracticeRef: ISerialisedDocumentReference;
  scheduledByStafferRef?: ISerialisedDocumentReference;
  movedFromPracticeRef?: ISerialisedDocumentReference;
  movedFromStafferRef?: ISerialisedDocumentReference;
  movedToPracticeRef?: ISerialisedDocumentReference;
  movedToStafferRef?: ISerialisedDocumentReference;
  scheduledAt: ISerialisedTimestamp;
  movedFromStartTime?: ISerialisedTimestamp;
  movedToStartTime?: ISerialisedTimestamp;
  eventBeforeDurationMins?: number;
  eventAfterDurationMins?: number;
  eventDurationChanged: boolean;
  eventMovedForward: boolean;
  eventMovedBackwards: boolean;
  eventPracticeChanged: boolean;
  eventPractitionerChanged: boolean;
  treatmentCost: number;
  isFirstAppointment: boolean;
  depositForfeiture?: IDepositForfeitureEventFact;
}
